import { atom } from 'recoil'

export const assetCategoriesAtom = atom({
    key: 'assetCategories',
    default: false,
})

export const assetTypesAtom = atom({
    key: 'assetTypes',
    default: false,
})

export const assetServiceTypesAtom = atom({
    key: 'assetServiceTypes',
    default: false,
})


export const newFormAssetTypeAtom = atom({
    key: 'newFormAssetType',
    default: false,
})

export const newFormCategoryAtom = atom({
    key: 'newFormCategory',
    default: false,
})